const onEnterOrSpacePress = (handler) => (e) =>
  handler && (e.key === 'Enter' || e.key === ' ') && handler(e);

export default onEnterOrSpacePress;
